import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	position: fixed;
	z-index: 9999;
	box-shadow: var(--container-box-shadow);
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-9);
	transition: opacity 0.3s;
	top: 7rem;
	right: 3rem;
	width: min-content;
	padding: var(--padding-1);
	@media ${Breakpoints.tablet} {
		display: none;
	}

	body[dir='rtl'] & {
		top: 7rem;
		right: unset;
		left: 3rem;
	}
	animation: myAnim 500ms ease 0s 1 normal forwards;

	@keyframes myAnim {
		0% {
			opacity: 0;
			transform: translateY(-75px);
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const Header = styled.div`
	padding: var(--padding-1);
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	color: #0c0c0c;
	font-size: 3rem;
	background-color: var(--white);
	> button {
		margin-top: calc(-1 * var(--margin-1));
	}
`;

export const LeftContainer = styled.div`
	display: flex;
`;
export const BottomContainer = styled.div`
	display: flex;
	justify-content: space-between;
	color: var(--black);
`;
